import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const MemoContext = createContext();

export const MemoProvider = ({ children }) => {
  const [memoData, setMemoData] = useState([]);
  const [status, setStatus] = useState("load");

  const fetchMemo = async () => {
    try {
      const response = await axios("/memos");
      setMemoData(response.data);
      if (response.data.length > 0) {
        setStatus("found");
      } else setStatus("x");
    } catch (error) {
      console.log(error);
      setStatus("x");
    }
  };

  useEffect(() => {
    setStatus("load");
    fetchMemo();
  }, []);

  return (
    <MemoContext.Provider
      value={{ memoData, fetchMemo, length: memoData.length, status }}
    >
      {children}
    </MemoContext.Provider>
  );
};
